import script from "./CongratulationsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CongratulationsSlider.vue?vue&type=script&setup=true&lang=js"

import "./CongratulationsSlider.vue?vue&type=style&index=0&id=90b1b1b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90b1b1b8"]])

export default __exports__